import { createFileRoute } from "@tanstack/react-router";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/users/technicians/create")({
  component: () => (
    <MaskRedirect
      to="/admin/users/technicians"
      action="create"
      mask="/admin/users/technicians/create"
    />
  ),
});
